<template>
    <v-popover ref="popover" :popover-class="classes" :open-group="id" :open="showPopover" @hide="showPopover = false" trigger="manual">
        <i @mouseenter="showPopover = true" class="fa fa-ellipsis-v tooltip-target"></i>
        <slot slot="popover" name="popover"></slot>
    </v-popover>
</template>

<script>
const ActionsPopoverComponent = {
    props: {
        id: {
            type: String,
            required: true
        },
        popoverClass: {
            type: String,
            required: false,
            default: ""
        }
    },

    data() {
        return {
            showPopover: false
        };
    },

    computed: {
        classes() {
            return "vue-popover-theme common-actions-popover " + this.popoverClass;
        }
    }
};

export default ActionsPopoverComponent;
</script>